import React from 'react'
import { useTranslation } from 'react-i18next'
import { getMeta } from '@/lib/utils'

const enabledMeta    = getMeta('branding-powered-by-enabled')
const poweredByName  = getMeta('branding-powered-by-text')  || 'Univo'
const poweredByColor = getMeta('branding-powered-by-color') || undefined
const poweredBySize  = getMeta('branding-powered-by-size')  || undefined

interface PoweredByProps {
  // 'auth' = white/60 on dark bg (login page default)
  // 'sidebar' = inherits parent color via opacity
  variant?: 'auth' | 'sidebar'
}

const PoweredBy: React.FC<PoweredByProps> = ({ variant = 'auth' }) => {
  const { t } = useTranslation()

  if (enabledMeta === 'false') return null

  const baseClass =
    variant === 'sidebar'
      ? 'text-xs opacity-50'
      : 'mt-8 text-xs text-white/60'

  return (
    <p
      className={baseClass}
      style={{ color: poweredByColor, fontSize: poweredBySize }}
    >
      {t('app.powered_by', { name: poweredByName })}
    </p>
  )
}

export default PoweredBy
